module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_Frame07-9885f36ee6232bb15e59fcd2893903bd.png";